import Card from "../card";
import Col from "../col";
import Row from "../row";
import { WizardStepWrapperProps } from "./types";

export default function WizardStepWrapper(
  props: Readonly<WizardStepWrapperProps>,
) {
  const { icon: Icon, title, description, action, status } = props;

  return (
    <Card className="rounded-xl shadow-xl">
      <Card.Header as={Row} centered gap="md">
        {Icon && (
          <Icon
            size="48"
            className="text-primary bg-primary-light rounded-xl p-2 shrink-0"
          />
        )}
        <Col className="flex-1">
          <Card.Title>{title}</Card.Title>
          {description && <Card.SubTitle>{description}</Card.SubTitle>}
        </Col>
        {!!action && typeof action === "function" ? action(status) : action}
      </Card.Header>
    </Card>
  );
}
